export class Kisi {
    constructor(
        public tcKimlikNo: string,
        public dogumTarihi: string,
        public cuzdanSeriNo: string,
        public eposta: string,
        public eposta2: string,
        public cepTel: string,
        public koyMukellefiyeti: boolean
    ) {
    }
}
